export default "__VITE_ASSET__DNBoZYMp__"